import { Outlet } from 'react-router-dom';

export default function SurveyLayout() {
  return (
    <div className="h-[100dvh] overflow-y-auto overflow-x-hidden bg-white">
      <Outlet />
    </div>
  );
}
